import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import plotly from './../node_modules/plotly.js/dist/plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
import DataUseCaseItemComponent from './DataUseCaseItemComponent';

const StyledDataUseCaseComponent = styled.div`
  position: relative;
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const UseCaseListHolder = styled.div`
  grid-column: 1;
  grid-row: 1;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 48px 16px;
  box-sizing: border-box;
  min-width: 0;
  min-height: 0;
  display: grid;
`;

class DataUseCaseComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createList(elements) {
    let list = [];
    elements.forEach(element => {
      list.push(<li>{element['Feature']}</li>);
    });
    return list;
  }

  createPlot(data) {
    const Plot = createPlotlyComponent(plotly);
    data[0].hole = 0.6;
    data[0].textposition = 'none';

    let layout = {
      height: 170,
      width: 170,
      showlegend: false,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 15
      },
      colorway: ['#f0f2f2', '#2cc4f4']
    };

    let config = {
      displayModeBar: false
    };

    return <Plot data={data} layout={layout} config={config} />;
  }

  getUseCases() {
    const data = JSON.parse(this.props.data);
    let output = [];
    let DataFields = '';
    data.forEach(element => {
      DataFields += element.Titel + ',' + element.API + ';';
      if (element.Base) {
        let v = (element.N / element.Base) * 100;
        let w = 100 - v;
        element.MiniChart[0].values = [v.toFixed(1), w.toFixed(1)];
      }
      output.push(
        <DataUseCaseItemComponent
          Titel={element.Titel}
          Description={element.Description}
          Features={element.Features}
          MiniChart={element.MiniChart}
          API={element.API}
          lastUpdated={this.props.lastUpdated}
          N={element.N}
          Action={element.Action}
          id={this.props.id}
        />
      );
    });
    return output;
  }

  render() {
    const { title, info } = this.props;

    return (
      <StyledDataUseCaseComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <UseCaseListHolder>{this.getUseCases()}</UseCaseListHolder>
      </StyledDataUseCaseComponent>
    );
  }
}

export default DataUseCaseComponent;
